// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__24xH5","list":"PatternAutocomplete_list__1TSf9"};